<template>
    <div class="components-renzhi-history">
        <el-table v-loading="loading" :data="tableData" style="width: 100%">
            <el-table-column prop="period" label="时间" width="220px"></el-table-column>
            <el-table-column prop="orgName" label="组织机构"></el-table-column>
            <el-table-column prop="stationName" label="岗位名称"></el-table-column>
            <!--<el-table-column  prop="subLevel" label="职级"></el-table-column>-->
            <el-table-column prop="directSuperior" label="直属上级"></el-table-column>
            <el-table-column prop="emprelatStatus" label="用工关系"></el-table-column>
            <el-table-column prop="changeCause" label="变动原因"></el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    props: {
        username: {
            type: String,
            require: true,
        },
    },
    data() {
        return {
            loading: false,
            get_data_api: "/user/personalCenter/postInfo",
            tableData: [],
        };
    },
    created() {
        this.getData();
    },
    methods: {
        getData() {
            this.loading = true;
            this.$axios
                .get(this.get_data_api, { username: this.username })
                .then((res) => {
                    this.loading = false;
                    this.tableData = res.body || [];
                })
                .catch(() => {
                    this.loading = false;
                });
        },
    },
};
</script>

<style scoped></style>
